module.exports = __webpack_public_path__ + "img/shipo-icon-loaded.ac295386.svg";